/**
 * The `date-fns` locale + BCP-47 tag for the current UI language.
 *
 * `date-fns` `format()` renders month and weekday names in English unless a `locale` is passed, so
 * every DISPLAY-format call in the calendar (and `RecoveryBanner`'s `formatDistanceToNow`) must
 * thread one of these through. Machine formats (`'yyyy-MM-dd'` keys/query params in
 * `features/calendar/datetime.ts`) must NOT — they are locale-independent identifiers.
 *
 * The BCP-47 tag (`de-DE` / `en-US`) is for `Number.toLocaleString()` grouping on user-facing
 * numbers (token meters, byte counts).
 */
import { de, enUS, type Locale } from 'date-fns/locale';
import { getLang, type Language } from './store';

export function dateLocaleFor(lang: Language): Locale {
  return lang === 'de' ? de : enUS;
}

/** The `date-fns` locale for the live language. Pass as `format(date, fmt, { locale })`. */
export function currentDateLocale(): Locale {
  return dateLocaleFor(getLang());
}

export function numberLocaleFor(lang: Language): string {
  return lang === 'de' ? 'de-DE' : 'en-US';
}

/** The BCP-47 tag for the live language, for `toLocaleString()`. */
export function currentNumberLocale(): string {
  return numberLocaleFor(getLang());
}
